import React from "react";

const Misc = {
  MobileSelectionTrayArrow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
    >
      <path
        d="M16 9.51477L9 2.99996L2 9.51477"
        stroke="#333333"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  ),
  
  MobileSelectionRemove: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M18.602 9.42681C18.7239 14.2587 14.9056 18.2745 10.0737 18.3964C5.24183 18.5182 1.22602 14.7 1.10417 9.86807C0.982323 5.03617 4.80057 1.02036 9.63247 0.898513C14.4644 0.776663 18.4802 4.59491 18.602 9.42681Z"
        fill="#D22923"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9975 9.44013C16.0115 9.99224 15.5752 10.4511 15.0231 10.465L5.12672 10.7146C4.57461 10.7285 4.11575 10.2922 4.10183 9.74011C4.0879 9.188 4.52419 8.72914 5.0763 8.71522L14.9726 8.46566C15.5248 8.45173 15.9836 8.88802 15.9975 9.44013Z"
        fill="white"
      />
    </svg>
  ),
  MobileSelectionRemoveAll: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="23"
      viewBox="0 0 18 23"
      fill="none"
    >
      <path
        d="M17.5161 1.87017H13.1371L11.8859 0.672485H5.63018L4.37903 1.87017H0V4.26554H17.5161M1.25115 19.8354C1.25115 20.4707 1.51479 21.08 1.98406 21.5292C2.45333 21.9784 3.0898 22.2308 3.75346 22.2308H13.7627C14.4263 22.2308 15.0628 21.9784 15.5321 21.5292C16.0013 21.08 16.265 20.4707 16.265 19.8354V5.46322H1.25115V19.8354Z"
        fill="#333333"
      />
    </svg>
  ),
  MobileSelectionEditComplete: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
    >
      <circle cx="15.5" cy="15.5" r="15.5" fill="#333333" />
      <path
        d="M24 9.99997L12 22L6.5 16.5L7.91 15.09L12 19.17L22.59 8.58997L24 9.99997Z"
        fill="white"
      />
    </svg>
  ),
  ProductInfoBtn: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <circle cx="8.5" cy="8.5" r="8" stroke="black" />
      <path
        d="M9.24902 12.6953H7.90332V7.65527C7.90332 7.3929 7.87793 7.21094 7.82715 7.10938C7.78483 6.99935 7.72135 6.93164 7.63672 6.90625C7.5013 6.86393 7.39128 6.81738 7.30664 6.7666C7.23047 6.71582 7.19238 6.63965 7.19238 6.53809C7.19238 6.30957 7.35742 6.19531 7.6875 6.19531H8.7666C9.08822 6.19531 9.24902 6.33919 9.24902 6.62695V12.6953ZM9.33789 4.13867C9.33789 4.38411 9.24902 4.5957 9.07129 4.77344C8.90202 4.94271 8.69466 5.02734 8.44922 5.02734C8.19531 5.02734 7.97949 4.94271 7.80176 4.77344C7.63249 4.5957 7.54785 4.38411 7.54785 4.13867C7.54785 3.90169 7.63249 3.69857 7.80176 3.5293C7.97949 3.35156 8.19531 3.2627 8.44922 3.2627C8.69466 3.2627 8.90202 3.35156 9.07129 3.5293C9.24902 3.69857 9.33789 3.90169 9.33789 4.13867Z"
        fill="black"
      />
    </svg>
  ),
  SelectionShuffleIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0410156 3.12111C0.0410156 2.9626 0.103985 2.81058 0.21607 2.69849C0.328155 2.58641 0.480176 2.52344 0.638688 2.52344H1.23636C3.86851 2.52344 5.81095 4.00567 7.06248 5.41378C7.6482 6.07361 8.09645 6.73105 8.40843 7.24505C8.71922 6.73105 9.16868 6.07361 9.75439 5.41378C11.0059 4.00567 12.9484 2.52344 15.5805 2.52344V3.71878C13.4313 3.71878 11.7877 4.92608 10.6485 6.20749C10.0326 6.90517 9.50353 7.67503 9.07305 8.50016C9.50316 9.32524 10.0318 10.0951 10.6473 10.7928C11.7889 12.0742 13.4337 13.2815 15.5805 13.2815V14.4769C12.9484 14.4769 11.0059 12.9947 9.75439 11.5865C9.25177 11.0177 8.8013 10.4048 8.40843 9.75528C8.09764 10.2693 7.6482 10.9267 7.06248 11.5865C5.81095 12.9947 3.86851 14.4769 1.23636 14.4769H0.638688C0.480176 14.4769 0.328155 14.4139 0.21607 14.3018C0.103985 14.1898 0.0410156 14.0377 0.0410156 13.8792C0.0410156 13.7207 0.103985 13.5687 0.21607 13.4566C0.328155 13.3445 0.480176 13.2815 0.638688 13.2815H1.23636C3.38559 13.2815 5.02919 12.0742 6.16836 10.7928C6.78432 10.0952 7.31334 9.3253 7.74382 8.50016C7.31371 7.67509 6.7851 6.90524 6.16955 6.20749C5.028 4.92608 3.3832 3.71878 1.23636 3.71878H0.638688C0.480176 3.71878 0.328155 3.65581 0.21607 3.54373C0.103985 3.43164 0.0410156 3.27962 0.0410156 3.12111Z"
        fill="white"
      />
      <path
        d="M15.5811 5.47099V0.770893C15.5811 0.714109 15.5973 0.658507 15.6278 0.610598C15.6582 0.562688 15.7017 0.524454 15.7532 0.500373C15.8046 0.476291 15.8618 0.46736 15.9181 0.474623C15.9744 0.481887 16.0275 0.505045 16.0711 0.541386L18.8922 2.89144C19.0356 3.01097 19.0356 3.23091 18.8922 3.35045L16.0711 5.7005C16.0275 5.73684 15.9744 5.76 15.9181 5.76726C15.8618 5.77452 15.8046 5.76559 15.7532 5.74151C15.7017 5.71743 15.6582 5.6792 15.6278 5.63129C15.5973 5.58338 15.5811 5.52777 15.5811 5.47099ZM15.5811 16.2291V11.529C15.5811 11.4722 15.5973 11.4166 15.6278 11.3687C15.6582 11.3208 15.7017 11.2826 15.7532 11.2585C15.8046 11.2344 15.8618 11.2255 15.9181 11.2327C15.9744 11.24 16.0275 11.2632 16.0711 11.2995L18.8922 13.6495C19.0356 13.7691 19.0356 13.989 18.8922 14.1086L16.0711 16.4586C16.0275 16.4949 15.9744 16.5181 15.9181 16.5254C15.8618 16.5326 15.8046 16.5237 15.7532 16.4996C15.7017 16.4755 15.6582 16.4373 15.6278 16.3894C15.5973 16.3415 15.5811 16.2859 15.5811 16.2291Z"
        fill="white"
      />
    </svg>
  ),
  SingleMsgTick: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="9"
      viewBox="0 0 13 9"
      fill="none"
    >
      <path
        d="M1.5 4.5L5.25 8L11.5 1"
        stroke="#5C2C94"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

export default Misc;
